import { queryKeys } from 'api/consts'
import { queryClient } from 'contexts/reactQuery'

import { UserCarousel } from 'types/Api'

import { FetchUserCarouselsResponse } from './types'

export const updateUserCarouselsQueryClient = (userCarousel?: UserCarousel) =>
  queryClient.setQueryData<FetchUserCarouselsResponse>(
    [queryKeys.userCarousels],
    {
      userCarousels: userCarousel ? [userCarousel] : [],
    },
  )
